import { PureComponent, createRef } from 'react';
import ConversationViewTitle from './ConversationViewTitle';
import ConversationViewCard from './ConversationViewCard';
import CorgeeStorageHelper from '@components/Globals/CorgeeStorageHelper';
import type { ConversationItemProps } from './types';
import './ConversationItem.css';

import '../../assets/fonts/glyphs/material-icons.css';
import '../../assets/fonts/glyphs/glyphs.css';
import '../../assets/fonts/glyphs-news/glyphs2.css';
import '@components/Globals/ComponentHelpers.css';
import '@components/Globals/ConversationSummernoteStyles.css';

class ConversationItem extends PureComponent<ConversationItemProps>
{
  private viewCardRef = createRef<ConversationViewCard>();

  constructor(props: ConversationItemProps)
  {
    super(props);
  }

  highlightCard(): void
  {
    this.viewCardRef.current?.highlightCard();
  }

  highlightHeader(): void
  {
    this.viewCardRef.current?.highlightHeader();
  }

  highlightBody(): void
  {
    this.viewCardRef.current?.highlightBody();
  }

  componentDidUpdate(prevProps: ConversationItemProps)
  {
    if (this.props.conversation && this.props.conversation !== prevProps.conversation)
    {
      CorgeeStorageHelper.loadData(this.props.conversation);
    }
  }

  sendError(conversationId: number)
  {
    if (this.props.corgeeFunctions?.onSendError)
    {
      this.props.corgeeFunctions.onSendError(conversationId);
    }
  }

  render()
  {
    const { conversation, isViewCard, hasArchivedFilter } = this.props;
    const itemClass = isViewCard
      ? 'liConversationCard liConversationItem corgee_com_conversation-item_container'
      : 'liConversationTitle liConversationItem corgee_com_conversation-item_container';

    const shouldHideConversation =
      (conversation.IsDeleted2 ||
        (conversation.IsArchived === true && hasArchivedFilter === false)) &&
      isViewCard === false;

    return (
      <li className={itemClass} style={{ position: 'relative', overflow: 'visible' }} data-react-conv={conversation.ConversationId}>
        {this.props.hasUnreadNotification && <span className="corgee-unread-dot" />}
        {!shouldHideConversation &&
          (isViewCard === false ? (
            <ConversationViewTitle {...this.props} />
          ) : (
            <ConversationViewCard ref={this.viewCardRef} {...this.props} />
          ))}
      </li>
    );
  }
}

export default ConversationItem;
